import { useSelector } from 'react-redux'

const useGetCompanyId = () => {
  const companyId = useSelector( state => state.common.user.license.company.id)
  return companyId;
}

export default useGetCompanyId;